import React, { useCallback, useEffect, useState } from 'react';

import { removePathsFromError, stringifyError } from 'shared/functions';

import Input from 'containers/Input';

import PageSpinner from '../Spinner/PageSpinner';
import SpinnerSmall from '../Spinner/SpinnerSmall';

import { ViewOnlyNote } from './ViewOnlyNote';

type EditNoteType = {
  initialData: string;
  isEditNote: boolean;
  submitting: boolean;
  toggleNoteEdit: () => void;
  onSubmit: (note: any) => Promise<any>;
};

export const EditNote: React.FC<EditNoteType> = ({
  submitting = false,
  initialData = '',
  isEditNote = false,
  toggleNoteEdit,
  onSubmit,
}) => {
  const [error, setError] = useState('');
  const [note, setNote] = useState(initialData);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setNote(initialData);
  }, [initialData]);

  const onChange = useCallback((evt) => setNote(evt.target.value), []);

  if (isLoading) {
    <PageSpinner />;
  }

  if (error) {
    return <h3 className="text-danger">{error}</h3>;
  }

  if (!isEditNote) {
    return <ViewOnlyNote note={note} />;
  }

  const handleCancel = () => {
    toggleNoteEdit();
    setNote(initialData);
  };

  const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      setError('');
      await onSubmit(note);
      toggleNoteEdit();
    } catch (e) {
      const errorWithoutPath = removePathsFromError(e);
      setError(stringifyError(errorWithoutPath));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Input
        value={note || ''}
        className="form-control"
        placeholder={translate('Add note')}
        onChange={onChange}
        autotrim
      />
      <div className="text-right margin-top margin-bottom">
        <button
          type="button"
          id="submit-note"
          onClick={(e) => handleSubmit(e)}
          disabled={submitting}
          className="btn btn-sm btn-success"
        >
          {submitting && <SpinnerSmall />} {translate('Submit')}
        </button>
        <button
          type="button"
          disabled={submitting}
          id="cancel-edit-language"
          className="btn btn-sm btn-default margin-left"
          onClick={handleCancel}
        >
          {submitting && <SpinnerSmall />} {translate('Cancel')}
        </button>
      </div>
    </div>
  );
};
